import React, { Component } from 'react';
import Navbar from './imgs/Components/Navbar';
import Store from './imgs/Components/Store';
import ProductPage from './imgs/Components/ProductPage';
import About from './imgs/Components/About';
import Stake from './imgs/Components/Stake';
import Home from './imgs/Components/Home'
import Roadmap from './imgs/Components/Roadmap'
import ComingSoon from './imgs/Components/ComingSoon'
import { BrowserRouter,  Routes, Route } from "react-router-dom";

export default class App extends Component {
  render() {
    return(
      <BrowserRouter>
      <Routes>
      <Route path="/store" element={<> <Navbar/> <Store/> </>}  />
      <Route path="/product" element={<> <Navbar/> <ProductPage/> </>}  />
      <Route path="/about" element={<> <Navbar/> <About/> </>}  />
      <Route path="/stake" element={<> <Navbar/> <Stake/> </>}  />
      <Route path="/" element={<> <Navbar/> <Home/> </>}  />
      <Route path="/*" element={<> <Navbar/> <ComingSoon/> </>}  />
      <Route path="/roadmap" element={<> <Navbar/> <Roadmap/> </>}  />
      </Routes>
      </BrowserRouter>
    )
  }
}
